<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="bannerUrl"></banner>
    <enterTitle></enterTitle>
    <div class="warp mb-60 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection()" :notStatus="status"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>发布需求</p>
              <span @click="toMore">更多 ></span>
            </div>
            <div class="saide_tree">
              <needsList :list="demandList"></needsList>
            </div>
          </div> -->
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" :props="defaultProps" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
          <!-- 供应产品 -->
          <div class="supply_products">
            <h3 class="tips">供应产品</h3>
            <div class="swiper-list">
              <div class="button-prev" @click="swiperChange('prev')">
                <svg
                  t="1603440419638"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2695"
                  width="32"
                  height="32"
                >
                  <path
                    d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
                    p-id="2696"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
              <div v-swiper:mySwiper="swiperOption">
                <div class="swiper-wrapper">
                  <div
                    @click="toProductDetail(item)"
                    class="swiper-slide box"
                    v-for="(item, index) in productList"
                    :key="index"
                  >
                    <img :src="item.cover" alt="" />
                    <p class="swiper-slide_title">{{ item.title }}</p>
                  </div>
                </div>
              </div>
              <div class="button-next" @click="swiperChange('next')">
                <svg
                  t="1603440337801"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2017"
                  width="32"
                  height="32"
                >
                  <path
                    d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
                    p-id="2018"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
            </div>
          </div>
          <!-- 企业宣传片 -->
          <div class="company_propaganda" v-if="videoUrl">
            <h3 class="tips">企业宣传片</h3>
            <div class="company_propaganda_content">
              <div class="company_video">
				          <videoPlayer :videoUrl="videoUrl"></videoPlayer>
              </div>          
              <div class="video_text">{{userInfo.publicizeVideoDesc}}</div>
            </div>
          </div>
          <!-- 公司简介 -->
          <div class="company_introduce">
            <div class="compan_tetx">
               <h3 class="tips">公司简介</h3>
                <p @click="onBrief()">更多 ></p>
            </div>
           
            <div class="company_introduce_content" v-html="userInfo.detail"></div>
          </div>
          <!-- 公司资讯 -->
          <div class="company_news"  v-if="info !=null">
            <div class="compan_tetx">
                 <h3 class="tips">公司资讯</h3>
                 <p @click="onMore()">更多 ></p>
            </div>   
            <div class="company_news_bg" @click="toDetail(info)">
              <img :src="info.cover" alt="" />
              <div class="company_news_content">
                <p>{{ info.title }}</p>
                <span>
                  {{ info.description }}
                </span>
                <span>详情 ></span>
              </div>
            </div>
            <ul class="company_list">
              <li v-for="(item, index) in newslist.slice(0,3)" :key="index" @click="toDetail(item)">
                <div>
                     <img :src="item.cover" alt="" />
                </div>
                <p>{{ item.title }}</p>
                <p>
                  <span>{{ item.createTime.substring(0, 10) }}</span>
                  <span>浏览数：{{ item.readCount }}</span>
                </p>
              </li>
            </ul>
          </div>
          <!-- 经典案例 -->
          <div class="classic_cases" v-if="caselist.length>0">
            <div class="compan_tetx">
                 <h3 class="tips">经典案例</h3>
                 <p @click="onCase()">更多 ></p>
            </div>
            <div class="classic_cases_content">
              <ul class="case_list">
                <li v-for="(item, index) in caselist" :key="index" @click="onDetail(item)">
                  <div>
                     <img :src="item.cover" alt="" />
                  </div>
                  <p>{{ item.title }}</p>
                  <p>
                    <span>{{ item.createtime.substring(0, 10) }}</span>
                    <span>浏览数：{{ item.visitcount }}</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <!-- 企业资质 -->
          <div class="enterprise_qualification"  v-if="userInfo.companyQualification != undefined && JSON.parse(userInfo.companyQualification).length>0">
            <h3 class="tips">企业资质</h3>
            <div class="mt-20">
              <el-carousel
                :interval="4000"
                type="card"
                :autoplay="false"
                height="200px"
                width="800px"
                indicator-position="none"
              >
                <el-carousel-item v-for="(item, index) in userInfo.companyQualification &&
                JSON.parse(userInfo.companyQualification)" :key="index">
                  <viewer>
                    <img class="viewer_img" :src="item.url" />
                  </viewer>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>
<script>
import { industryinfoList, releaseLists, supplyList,suppType } from "@/api/company";
import { addCollection, iscollection } from "@/api/coment";
import { getToken } from "@/utils/auth";
import { getUserInfo,getDemandList} from "@/api/information";
import headEnterprise from "../../common/headEnterprise";
import footCom from "../../common/footCom";
import banner from "../../common/banner";
import needsList from "../../components/needsList";
import enterTitle from "../../common/enterTitle";
import baseInfo from "@/components/companyintroCard";
import videoPlayer from '@/components/videoPlayer'

export default {
  components: {
    headEnterprise,
    banner,
    needsList,
    footCom,
    baseInfo,
    enterTitle,
	videoPlayer
  },
  data() {
    return {
      banner: {
        title: "公司首页",
        isShow: false,
        isColor: true,
        type: "",
        usertype: "",
        companytype: "",
        bannerUrl: "",
      },
      data: [],
	  defaultProps:{
		children: "children",
		label: "name"
	  },
      swiperOption: {
        slidesPerView: 4, // 显示的数量
        spaceBetween: 10, // 每张的间距
        slidesPerGroup: 1,
      },
      id: "",
      newslist: [],
      newslistQuery: {
        curPage: 1,
        limit: 4,
      },
      caselist: [],
      caselistQuery: {
        curPage: 1,
        limit: 4,
      },
      productlistQuery: {
        curPage: 1,
        limit: 10,
      },
      total:0,
      productList: [],
      demandList: [],
      userInfo: {},
      status: false,
      id: "",
      demandList:[],
      info:{},
	  videoUrl:''
    };
  },
  created() {
    if (this.$route.query.id) {
      sessionStorage.setItem("corporateId", this.$route.query.id);
    }
    this.$store.dispatch("company/getBaseInfo");
    this.id = this.$route.query.id || sessionStorage.getItem('corporateId');
      
    if (this.id != null) {
       this.getProductList();
       this.getCaseList();
       this.getNewsList();
       this.getCompanyDetail(this.id); 
       this.guserinfo();
	   this.getSuppType();
    }

    if (getToken() != undefined) {
      if (this.id != null) {
         this.getIscollection();
      }
    }
    // if(this.$store.state.user.userInfo != null){
    //    this.banner.usertype = this.$store.state.user.userInfo.type;
    // }
  },
  computed: {
    bannerUrl() {
      return { bannerUrl: this.$store.getters.companyInfo.banner };
    },
  },
  watch:{},
  methods: {
    getCompanyDetail(id) {
      sessionStorage.setItem("corporateId", id);
      this.$store.dispatch("company/getBaseInfo");
    },
    guserinfo() {
        getUserInfo({ id:Number(this.id)})
          .then((res) => {
            if (res.code == 0) {
              this.userInfo = res.data;
              this.getMate(res.data)
              this.videoUrl = res.data.publicizeVideo;
              console.log(this.videoUrl)
              // this.banner.companytype = res.data.companyType;
            }
          }).catch((err) => {});
    },
    toMore() {
      this.$router.push({
        path: "/corporate_demand",
      });
    },
    toProductDetail(item) {
      this.$router.push({
        path: "/supply_detail",
        query: { id: item.userid || item.id },
      });
    },
    //获取推荐产品
    getProductList() {
      supplyList({
        ...this.productlistQuery,
        // recommend: 1,
        userid: this.id,
      }).then((res) => {
          if (res.code == 0) {
            this.total  = res.page.totalCount;
            this.productList = this.productList.concat(res.page.list);
          }
        }).catch((err) => {});
    },
    //跳转资讯详情
    toDetail(item) {
      this.$router.push({
        path: "/info_detail",
        query: { id: item.id },
      });
    },
    //案例详情
    onDetail(item){
      this.$router.push({
        path: "/corporate_case_detail",
        query: { id: item.id },
      });
    },
    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;

        default:
          this.mySwiper.slideNext();
          if(this.mySwiper.slideNext() == false){
             this.productlistQuery.curPage ++;
             if(this.total == this.productList.length) return;
             this.getProductList();
          }
          break;
      }
    },
    //获取资讯列表
    getNewsList() {
      industryinfoList({ ...this.newslistQuery,releaseType:2, userid: this.id })
        .then((res) => {
          if(res.code == 0){
            this.info = res.page.list[0];
            let att = [];
            res.page.list.map((item)=>{
              if(this.info.id == item.id) return;
              att.push(item);
            })
	      	this.newslist = att;
          }    
        })
        .catch((err) => {});
    },
    //获取案例列表
    getCaseList() {
      releaseLists({ ...this.caselistQuery, userid:this.id  })
        .then((res) => {
          if (res.code == 0) {
            this.caselist = res.page.list;
          }
        })
        .catch((err) => {});
    },
    //查询企业发布的需求
    getDemand(){
       getDemandList({
         curPage:1,
         limit:4,
         userid:this.id
       }).then((res)=>{
         if(res.code == 0){
           this.demandList = res.page.list
         }
       }).catch((err)=>{})

    },
	//获取 公司发布的产品分类
	getSuppType(){
	  let params = {user_id:this.id};
	  suppType({params}).then((res)=>{
		if(res.code == 0){
		   this.data = res.data;
		}
	  }).catch((err)=>{})
	},
	
    //企业收藏
    goCollection() {
      let params = {
        goodsId: this.id,
        goodsType: 7,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "收藏成功",
            });
          }
        })
        .catch((err) => {});
    },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.id,
        goodstype: 7,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
	//公司资讯
    onMore(){
      this.$router.push('/corporate_list_all');
    },
	//经典案列
    onCase(){
       this.$router.push('/corporate_case_all');
    },
	// 公司简介
    onBrief(){
       this.$router.push('/corporate_introduce');
    },

    // SEO优化
    getMate(data) {
      console.log("SEO详细信息")
      console.log(data)
      var metas = document.getElementsByTagName("meta");
      // 关键字
      if(data.seokeywords && data.seokeywords != null){
        metas[0].name = "keywords";
        metas[0].content = data.seokeywords;
      }
      // 描述
      if(data.seodescription && data.seodescription != null){
        metas[1].name = "description";
        metas[1].content = data.seodescription;
      }
      // 标题
      document.getElementsByTagName("title")[0].innerText = data.name+'_智污邦环保服务平台';
    },
  },
};
</script>
<style scoped lang="less">
.el-main {
  text-align: inherit;
}
.mt-30 {
  margin-top: 30px;
}
.tips {
  position: relative;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 10px;
  margin-bottom: 10px;
  &::before {
    position: absolute;
    left: 0;
    bottom: 4px;
    display: inline-block;
    content: "";
    width: 5px;
    height: 23px;
    background: #ff7302;
  }
}
.supply_products {
  margin-bottom: 20px;
  .swiper-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .button-prev,
    .button-next {
      cursor: pointer;
      // position: absolute;
      // top: 25%;
      z-index: 999;
    }
    .swiper-container {
      width: 100%;
      .box {
        margin-right: 10px;
        min-width: 152px;
        cursor: pointer;
        img {
          width: 100%;
          height: 110px;
        }
        p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:nth-of-type(1) {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            margin-top: 5px;
          }
          &:nth-of-type(2) {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }
}
.company_propaganda {
  margin-bottom: 20px;
  .company_propaganda_content {
    width: 100%;
    margin-top: 20px;
  }
}
.company_introduce {
  margin-bottom: 20px;
  .company_introduce_content {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    max-height: 500px;
    overflow: auto;
    // overflow: hidden;
  }
}
.company_news {
  margin-bottom: 20px;
  .company_news_bg {
    display: flex;
    justify-content: space-between;
    margin-bottom: 15px;
    cursor: pointer;
    img {
      width: 60%;
      height: 250px;
    }
    .company_news_content {
      width: 40%;
      height: 250px;
      background: #02b754;
      padding: 40px 20px;
      display: flex;
      flex-direction: column;
      p {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
      }
      span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
        &:nth-of-type(1) {
          margin: 10px 0;
          overflow: hidden;
          height: 57px;
          display: -webkit-box;//将元素设为盒子伸缩模型显示
          -webkit-box-orient: vertical;//伸缩方向设为垂直方向
          -webkit-line-clamp: 3;//超出3行隐藏，并显示省略号
        }
        &:nth-of-type(2) {
          cursor: pointer;
        }
      }
    }
  }
  ul {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
	max-height: 240px;
    li {
      width: 31%;
      height: 252px;
      border: 1px solid #EBEBEB;
      cursor: pointer;
      &:last-of-type {
        margin-right: 0;
      }
      div{
        width: 100%;
        height: 155px;
        overflow: hidden;
        img{
          width: 100%;
          height:100%;
          transition: all 0.6s;
        }
        img:hover{
         transform: scale(1.1);
       }
      }     
      p {
        &:nth-of-type(1) {
          margin: 10px 0;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          padding: 0px 10px;
        }
        &:nth-of-type(2) {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          padding: 0px 10px;
        }
      }
    }
  }
  .company_list::after{
      content: '';
      width: 218px;
  }
}
.classic_cases {
  margin-bottom: 20px;
  .classic_cases_content {
    ul {
      display: flex;
      justify-content: space-between;
      li {
        width: 31%;
        // border: 1px solid #EBEBEB;
        &:last-of-type {
          margin-right: 0;
        }
        div{
          width: 100%;
          height: 162px;
          overflow: hidden;
          img {
            width: 100%;
            height:100%;
            transition: all 0.6s;
          }
          img:hover {
            cursor: pointer;
            transform: scale(1.1);
         }
        }
        p {
          &:nth-of-type(1) {
            margin: 10px 0;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            height: 42px;
          }
          &:nth-of-type(2) {
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }&::after{
      content: '';
      width: 218px;
    }
  }
}
.enterprise_qualification {
  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    li {
      width: 32%;
      margin-right: 2%;
      margin-bottom: 20px;
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}

.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.saide_mater {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}
.swiper-slide_title {
  font-size: 16px;
}

.wires {
  border-bottom: 1px solid #eeeeee;
  margin-top: 20px;
}

.mt-10 {
  margin-top: 10px;
}
.mb-60 {
  margin-bottom: 60px;
}

.viewer_img{
  height: 180px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}
.video_text{
	margin-top: 10px;
	text-align: left;
	font-size: 14px;
	max-height: 80px;
	color: #666666;
	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient:vertical;
	-webkit-line-clamp:3;
}
.compan_tetx{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.compan_tetx p{
	font-size: 14px;  
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #999999;
}
.compan_tetx p:hover{
	cursor: pointer;
	color: #02b754;
}
</style>
<style scoped>
.company_introduce_content >>>div a img{
  width: 100% !important;
}
.company_introduce_content >>>p img{
  width: 100% !important;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_detail.vue